"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const logger_1 = __importDefault(require("../logger"));
const defaultLogger = new logger_1.default("WindowMessage");
class WindowMessageTransport {
    constructor(target = window, logger = defaultLogger) {
        this.connect = () => {
            var _a;
            this.target.addEventListener("message", this._onMessageEvent, false);
            // @ts-ignore (FIXME)
            (_a = this.target.document) === null || _a === void 0 ? void 0 : _a.addEventListener("message", this._onMessageEvent, false);
            this.logger.debug("event listeners registered");
        };
        this.disconnect = () => {
            var _a;
            this.target.removeEventListener("message", this._onMessageEvent);
            // @ts-ignore (FIXME)
            (_a = this.target.document) === null || _a === void 0 ? void 0 : _a.removeEventListener("message", this._onMessageEvent, false);
            this.logger.debug("event listeners unregistered");
        };
        this._onMessageEvent = (event) => {
            if (this._onMessage) {
                this.logger.debug("received message event", event);
                if (event.origin !== this.target.location.origin &&
                    event.data &&
                    typeof event.data === "string") {
                    try {
                        const payload = JSON.parse(event.data.toString());
                        // TODO: find a better way to ensure message comes from LL
                        if (payload.jsonrpc) {
                            this.logger.log("received message", payload);
                            // FIXME
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            this._onMessage(payload);
                        }
                        else {
                            this.logger.debug("not a jsonrpc message");
                        }
                    }
                    catch (error) {
                        this.logger.warn("parse error");
                        // FIXME
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        this._onMessage(error);
                    }
                }
                else {
                    this.logger.debug("ignoring message same origin");
                }
            }
            else {
                this.logger.debug("no handler registered");
            }
        };
        this.send = (response) => {
            try {
                // @ts-ignore
                if (this.target.ReactNativeWebView) {
                    this.logger.log("sending message (ReactNativeWebview)", response);
                    // @ts-ignore
                    this.target.ReactNativeWebView.postMessage(JSON.stringify(response));
                }
                // @ts-ignore
                else if (this.target.ElectronWebview) {
                    this.logger.log("sending message (ElectronWebview)", response);
                    // @ts-ignore
                    this.target.ElectronWebview.postMessage(JSON.stringify(response));
                }
                else {
                    this.logger.log("sending message", response);
                    // @ts-ignore
                    this.target.top.postMessage(JSON.stringify(response), "*");
                }
                return Promise.resolve();
            }
            catch (error) {
                this.logger.error("unexpected error on send", error);
                return Promise.reject(error);
            }
        };
        this.target = target;
        this.logger = logger;
    }
    set onMessage(handler) {
        this._onMessage = handler;
    }
    get onMessage() {
        return this._onMessage;
    }
}
exports.default = WindowMessageTransport;
